import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  List,
  SimpleGrid,
} from "@chakra-ui/react";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useState } from "react";
import { CardRegistration } from "components/CardRegistration";

const width1 = "8rem";

const fs = "sm";

// const items = [
//   {
//     id: 1,
//     Attached: "Attached",
//     "Group Name": "Group Name",
//   },
// ];

const Content = () => {
  // const [address1, setAddress1] = useState();
  // const [address2, setAddress2] = useState();
  // const [address3, setAddress3] = useState();
  // const [company, setCompany] = useState();
  // const [country, setCountry] = useState();
  // const [email, setEmail] = useState();
  // const [forename, setForename] = useState();
  // const [hometel, setHometel] = useState();
  // const [mobile, setMobile] = useState();
  // const [policyid, setPolicyid] = useState();
  // const [policynumber, setPolicynumber] = useState();
  const [postcode, setPostcode] = useState();
  // const [surname, setSurname] = useState();
  // const [title, setTitle] = useState();
  // const [town, setTown] = useState();
  // const [recordtype, setRecordtype] = useState();
  // const [branchid, setBranchid] = useState();
  // const [branchname, setBranchname] = useState();
  // const [dateseconds, setDateseconds] = useState();
  // const [coverid, setCoverid] = useState();
  // const [operator, setOperator] = useState();
  // const [state, setState] = useState();
  // const [datepolicy, setDatepolicy] = useState();
  // const [invoiceid, setInvoiceid] = useState();
  // const [nett, setNett] = useState();
  // const [tax, setTax] = useState();
  // const [gross, setGross] = useState();
  // const [invoicenumber, setInvoicenumber] = useState();
  // const [vatpercent, setVatpercent] = useState();
  // const [county, setCounty] = useState();
  // const [poladmincosttype, setPoladmincosttype] = useState();
  // const [poladmincostcent, setPoladmincostcent] = useState();
  // const [poladmincostamt, setPoladmincostamt] = useState();
  // const [pricepaid, setPricepaid] = useState();
  // const [deposit, setDeposit] = useState();
  // const [notifyemail, setNotifyemail] = useState();
  // const [policycommissionaccount, setPolicycommissionaccount] = useState();
  // const [policycommissiontype, setPolicycommissiontype] = useState();
  // const [policycommissionamt, setPolicycommissionamt] = useState();
  // const [policycommissioncent, setPolicycommissioncent] = useState();
  // const [policycommissionvalue, setPolicycommissionvalue] = useState();
  // const [policycommissionpaytype, setPolicycommissionpaytype] = useState();
  // const [vatcalculation, setVatcalculation] = useState();
  // const [policyrefundtype, setPolicyrefundtype] = useState();
  // const [policyrefundvalue, setPolicyrefundvalue] = useState();
  // const [policyrefundduration, setPolicyrefundduration] = useState();
  // const [refunddone, setRefunddone] = useState();
  // const [taxadmin, setTaxadmin] = useState();
  // const [dateexpiry, setDateexpiry] = useState();
  // const [renewnotified, setRenewnotified] = useState();
  // const [accepted, setAccepted] = useState();
  // const [customersent, setCustomersent] = useState();
  // const [customerstripeid, setCustomerstripeid] = useState();
  // const [carmake, setCarmake] = useState();
  // const [carmodel, setCarmodel] = useState();
  // const [cartype, setCartype] = useState();
  // const [enginecapacity, setEnginecapacity] = useState();
  const [fourbyfour, setFourbyfour] = useState();
  // const [fueltype, setFueltype] = useState();
  const [luxury, setLuxury] = useState();
  const [mileage, setMileage] = useState();
  // const [purchaseprice, setPurchaseprice] = useState();
  const [specialist, setSpecialist] = useState();
  // const [transmission, setTransmission] = useState();
  // const [vin, setVin] = useState();
  // const [vrm, setVrm] = useState();
  // const [vehicleid, setVehicleid] = useState();
  // const [extranum, setExtranum] = useState();
  // const [datepurchase, setDatepurchase] = useState();
  // const [regdate, setRegdate] = useState();
  // const [policynumber, setPolicynumber] = useState();
  // const [carcolour, setCarcolour] = useState();
  // const [policyidvehicle, setPolicyidvehicle] = useState();
  // const [guaranteeid, setGuaranteeid] = useState();
  // const [startdate, setStartdate] = useState();
  // const [covertype, setCovertype] = useState();
  // const [vehiclecategory, setVehiclecategory] = useState();
  // // const [durationid, setDurationid] = useState();
  // const [mileageband, setMileageband] = useState();
  // const [dpfs, setDpfs] = useState();
  // const [higherlabourrate, setHigherlabourrate] = useState();
  // const [weartear, setWeartear] = useState();
  // const [egrvalves, setEgrvalves] = useState();
  // const [catalyticconverter, setCatalyticconverter] = useState();
  // const [retailprice, setRetailprice] = useState();
  // const [policynumber, setPolicynumber] = useState();
  // const [claimlimitamount, setClaimlimitamount] = useState();
  // const [claimlimitid, setClaimlimitid] = useState();
  // const [coverid, setCoverid] = useState();
  // const [startdateseconds, setStartdateseconds] = useState();
  // const [policyidguarantee, setPolicyidguarantee] = useState();
  // const [durationid, setDurationid] = useState();
  // const [durationtype, setDurationtype] = useState();
  // const [active, setActive] = useState();
  // const [hide, setHide] = useState();
  // const [durationvalue, setDurationvalue] = useState();

  const location = useLocation();
  const [action] = useState(location?.state?.action);
  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();

  // const onSave = () => {
  //   navigate("/");
  // };

  // const onClose = () => {
  //   navigate("/");
  // };

  const onNext = () => {
    navigate("/guarantee");
  };

  // const onPrev = () => {
  //   navigate(-1);
  // };

  return (
    <>
      <Heading size="4xl" color="primary" mt="2.5" mb="2.5">
        Vehicle Details - {action}
      </Heading>
      <Flex
        wrap={"wrap"}
        columns={ismobile ? 1 : 3}
        columnGap="2rem"
        rowGap="2"
        mt="5"
        alignItems={"center"}
      >
        <Box>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>VRM</Field.Label>
          </Field.Root>
        </Box>
        <CardRegistration value={"xyz123"} />
        <Button w={width1} bg="primary" textStyle={fs}>
          Lookup
        </Button>
      </Flex>
      {/* <Flex flexFlow={"wrap"} columnGap="2rem" rowGap="2"> */}
      {/* <Text fontWeight={"bold"} textStyle={fs}>
            Registration
            </Text> */}
      {/* <Flex> */}
      {/* </Flex> */}
      {/* <Flex> */}
      {/* <Field.Root orientation="horizontal" gap={4}></Field.Root> */}
      {/* </Flex> */}
      {/* // </Flex> */}
      <SimpleGrid columns={ismobile ? 1 : 3} columnGap="2rem" rowGap="2" mt="5">
        <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Mileage</Field.Label>
          <Input
            type="text"
            value={mileage}
            onChange={(e) => setMileage(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>
        <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Title</Field.Label>
          <Input type="text" textStyle={"md"} />
        </Field.Root>
        <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>First Name</Field.Label>
          <Input type="text" textStyle={"md"} />
        </Field.Root>
        <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Last Name</Field.Label>
          <Input type="text" textStyle={"md"} />
        </Field.Root>

        <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Post Code</Field.Label>
          <Input
            type="text"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>
        <Button w={"12rem"} variant={"outline"}>
          Find Address
        </Button>
      </SimpleGrid>
      <Flex direction={"column"} gap={4}>
        <Flex flexFlow={"wrap"} gap={6} mt={4}>
          <ToggleSwitch
            label={"4x4"}
            value={fourbyfour}
            onChange={setFourbyfour}
          />
          <ToggleSwitch label={"Luxury"} value={luxury} onChange={setLuxury} />
          <ToggleSwitch
            label={"Specialist"}
            value={specialist}
            onChange={setSpecialist}
          />
        </Flex>
      </Flex>
      <Flex
        direction={ismobile ? "column" : "row"}
        justifyContent="space-between"
        alignItems="center"
        mt={"2rem"}
      >
        <Box />
        {/* <Text fontWeight={"bold"} textStyle={"lg"} alignSelf={"flex-end"}>
            Clear
          </Text> */}
        <Button
          w={"12rem"}
          onClick={() => onNext()}
          bg="primary"
          textStyle={"md"}
        >
          Get Quote
        </Button>
      </Flex>
    </>
  );
};

function CustomPricing() {
  return (
    <Box>
      <Flex>
        <List.Root overflowY={"scroll"} h="100vh" w="100%" p="10">
          <Content />
        </List.Root>
      </Flex>
    </Box>
  );
}

export default CustomPricing;
